export default "__VITE_ASSET__996da1d2__"